import { AnecdotesCommentingModule } from '@anecdotes/commenting';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule, Type } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { ButtonsModule } from '@anecdotes/design-system/buttons';
import { DropdownAtomsModule, DropdownMenuModule } from '@anecdotes/design-system/dropdown-menu';
import { FormControlsModule } from '@anecdotes/design-system/form-controls';
import { RenderingModule } from '@anecdotes/design-system/rendering';
import { UtilsModule } from '@anecdotes/design-system/utils';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import {
  CommentingPanelComponent,
  CommentBubbleComponent,
  BackToAllCommentsActionComponent,
  CommentViewComponent,
  CommentInputComponent,
  SavableCommentInputComponent,
  ThreadCreationComponent,
  ThreadHeaderComponent,
  ThreadItemComponent,
  ReplyComponent,
  ThreadStateFilterComponent,
  ActiveThreadComponent,
  ResolvedThreadComponent,
  ResolveButtonComponent,
  NoCommentsEmptyStateComponent,
  DeleteAllActionComponent,
  CommentingPanelButtonComponent,
  CommentingUserLogoComponent,
  ThreadGroupViewComponent,
  ThreadGroupCommentViewComponent,
  BaseThreadComponent,
  ThreadSortingComponent,
  AbstractCommentButtonComponent,
  ResourceRelatedCommentButtonComponent,
} from './components';
import {
  CommentingConfigurationProviderService,
  CommentingTokenProviderService,
  CommentPanelManagerService,
  ConfirmationModalService,
  CommentingFacadeService,
  CommentingUserEventsService,
  AbstractCommentingUiConfigurationProvider,
  FocusingService,
} from './services';
import { featureKey, reducers } from './store';
import { SvgIconsModule } from '@anecdotes/design-system/svg-icons';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { DirectivesModule } from '@anecdotes/design-system/directives';
import { AuthCoreModule } from '@anecdotes/auth-core';
import { EffectsModule } from '@ngrx/effects';
import { effects } from './store/effects';
import { DataSortModule } from '@anecdotes/design-system/data-manipulation';
import { FeatureFlagsModule } from '@anecdotes/feature-flags';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RenderingModule,
    DropdownMenuModule,
    DropdownAtomsModule,
    RenderingModule,
    DropdownMenuModule,
    FormControlsModule,
    UtilsModule,
    StoreModule.forFeature(featureKey, reducers),
    PerfectScrollbarModule,
    ButtonsModule,
    ReactiveFormsModule,
    SvgIconsModule,
    NgbTooltipModule,
    TranslateModule,
    DirectivesModule,
    AnecdotesCommentingModule,
    AuthCoreModule,
    DataSortModule,
    FeatureFlagsModule
  ],
  declarations: [
    CommentingPanelComponent,
    ThreadItemComponent,
    CommentViewComponent,
    CommentBubbleComponent,
    BackToAllCommentsActionComponent,
    ThreadHeaderComponent,
    ThreadCreationComponent,
    CommentingPanelButtonComponent,
    CommentInputComponent,
    SavableCommentInputComponent,
    ReplyComponent,
    ThreadStateFilterComponent,
    ActiveThreadComponent,
    ResolvedThreadComponent,
    ResolveButtonComponent,
    NoCommentsEmptyStateComponent,
    DeleteAllActionComponent,
    CommentingUserLogoComponent,
    ThreadGroupViewComponent,
    ThreadGroupCommentViewComponent,
    BaseThreadComponent,
    ThreadSortingComponent,
    AbstractCommentButtonComponent,
    ResourceRelatedCommentButtonComponent,
  ],
  exports: [
    CommentingPanelComponent,
    CommentBubbleComponent,
    CommentingPanelButtonComponent,
    ResourceRelatedCommentButtonComponent,
    CommentInputComponent
  ],
})
export class CommentingUiModule {
  static forRoot(commentingUiConfigType: Type<AbstractCommentingUiConfigurationProvider>): ModuleWithProviders<CommentingUiModule> {
    return {
      ngModule: CommentingUiModule,
      providers: [
        ...AnecdotesCommentingModule.forRoot(CommentingConfigurationProviderService, CommentingTokenProviderService)
          .providers,
        ...EffectsModule.forFeature(effects).providers,
        CommentPanelManagerService,
        ConfirmationModalService,
        CommentingFacadeService,
        CommentingUserEventsService,
        FocusingService,
        { provide: AbstractCommentingUiConfigurationProvider, useClass: commentingUiConfigType }
      ],
    };
  }
}
